<app-uzemszunet-sav forras="ugyfelkapu"></app-uzemszunet-sav>

<div class="naplo-fejlec">
  <h2>Ügyfélkapu-fiókok</h2>
  <span class="n-alcim">Szervíz · KAÜ-belépések és élő TOTP-kódok</span>
  <div class="spacer"></div>
  <ion-button (click)="uj()">
    <ion-icon slot="start" name="add"></ion-icon> Új fiók
  </ion-button>
</div>

<div *ngIf="!fiokok.length" class="ures">
  <ion-icon name="key-outline"></ion-icon>
  Még nincs tárhely-fiók. Vegyél fel egyet (login + jelszó + TOTP secret) – egy fiók több ügyfélhez is hozzárendelhető.
</div>

<!-- Élő TOTP authenticator -->
<div class="auth-grid">
  <div class="auth-card" *ngFor="let f of fiokok" [class.hibas]="f.belepes_hiba">
    <div class="kor" [style.background]="'conic-gradient(' + korSzin() + ' ' + korPct() + '%, #e2e8f0 0)'">
      <div class="belso">{{ remaining }}</div>
    </div>
    <div class="info">
      <div class="cimke">{{ f.cimke || f.login }}</div>
      <div class="login">{{ f.login }}</div>
      <div class="kod" [class.nincs]="!kodFor(f.id)?.code" (click)="masol(kodFor(f.id)?.code)" title="Kattints a másoláshoz">
        {{ kodFor(f.id)?.code || (f.van_totp ? '••••••' : 'nincs TOTP') }}
      </div>
    </div>
    <div class="muvelet">
      <ion-button size="small" fill="clear" *ngIf="kodFor(f.id)?.code" (click)="masol(kodFor(f.id)?.code)"><ion-icon slot="icon-only" name="copy-outline"></ion-icon></ion-button>
      <ion-button size="small" fill="clear" (click)="szerkeszt(f)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
      <ion-button size="small" fill="clear" color="danger" (click)="torol(f)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
    </div>
    <!--  Sikertelen belépés: a fiók minden lekérése szünetel, amíg a belépési adatot nem javítják
          (mentés új jelszóval / TOTP-vel), vagy egy ellenőrző belépés nem sikerül. -->
    <div class="belepes-hiba" *ngIf="f.belepes_hiba" [class.ugyfel]="f.belepes_hiba_kinek === 'ugyfel'">
      <div class="bh-cim"><ion-icon name="warning"></ion-icon> Belépés sikertelen – a szinkron szünetel{{ f.belepes_hiba_ido ? ' (' + f.belepes_hiba_ido + ')' : '' }}</div>
      <div class="bh-ok">{{ f.belepes_hiba }}</div>
      <div class="bh-teendo">{{ f.belepes_hiba_kinek === 'ugyfel'
        ? 'Teendő: ügyfél – a KAÜ-fiókja zárolt vagy lejárt; ha feloldotta, ellenőrizd újra a belépést.'
        : 'Teendő: könyvelő – írd át a jelszót vagy a TOTP-kulcsot (mentéskor a szinkron újraindul).' }}</div>
      <div class="bh-gombok">
        <ion-button size="small" fill="outline" (click)="szerkeszt(f)"><ion-icon slot="start" name="create-outline"></ion-icon>Adatok javítása</ion-button>
        <ion-button size="small" fill="outline" [disabled]="ellenorzes === f.id" (click)="ellenoriz(f)">
          <ion-icon slot="start" name="refresh"></ion-icon>{{ ellenorzes === f.id ? 'Belépés…' : 'Belépés ellenőrzése' }}
        </ion-button>
      </div>
    </div>

  </div>
</div>

<!--  CÉG → FIÓK. Fiókból kevés van, cégből sok: a hozzárendelést a cégek listájáról vezetjük,
      így egy helyen látszik, kinek van (és kinek nincs) KAÜ-belépése. -->
<div class="ceg-szekcio" *ngIf="fiokok.length">
  <div class="ceg-fej">
    <h3><ion-icon name="business-outline"></ion-icon> Cégek és ügyfélkapujuk</h3>
    <ion-searchbar [(ngModel)]="kereses" placeholder="Cég vagy adószám" style="max-width:280px; --box-shadow:none"></ion-searchbar>
    <ion-item lines="none" class="kapcsolo">
      <ion-checkbox slot="start" [(ngModel)]="csakHianyzo"></ion-checkbox>
      <ion-label>Csak akinek nincs fiókja</ion-label>
    </ion-item>
    <span class="spacer"></span>
    <span class="halvany">{{ cegSorok.length }} cég</span>
  </div>

  <div class="tabla-wrap">
    <table class="naplo-tabla">
      <thead><tr><th>Cég</th><th>Adószám</th><th>Ügyfélkapu / cégkapu</th><th style="width:130px"></th></tr></thead>
      <tbody>
        <tr *ngFor="let u of cegSorok" [class.hianyzik]="!cegFiokjai(u).length">
          <td>{{ u.nev }}</td>
          <td class="halvany">{{ u.adoszam || '—' }}</td>
          <td>
            <span class="ceg-chip" *ngFor="let p of cegFiokjai(u)" [class.hibas]="fiokHibas(p.fiok_id)"
                  [title]="fiokHibas(p.fiok_id) ? 'A fiók belépése sikertelen – a szinkron szünetel' : ''">
              <ion-icon name="warning" class="hiba-ikon" *ngIf="fiokHibas(p.fiok_id)"></ion-icon>
              {{ fiokCimke(p) }}
              <small>· {{ p.tipus === 'cegkapu' ? 'cégkapu' : 'ügyfélkapu' }}</small>
              <small *ngIf="p.mailbox_nev">· {{ p.mailbox_nev }}</small>
              <ion-icon name="close" (click)="hozzarendelesTorol(p, u.nev)" title="Leválasztás"></ion-icon>
            </span>
            <span class="halvany" *ngIf="!cegFiokjai(u).length">nincs hozzárendelve</span>

            <div class="ceg-uj" *ngIf="hozza?.ugyfel_id === u.id">
              <ion-select [(ngModel)]="hozza.fiok_id" interface="popover" label="Fiók" style="min-width:190px">
                <ion-select-option *ngFor="let f of fiokok" [value]="f.id">{{ f.cimke || f.login }}</ion-select-option>
              </ion-select>
              <ion-select [(ngModel)]="hozza.tipus" interface="popover" label="Típus" style="max-width:150px">
                <ion-select-option value="ugyfelkapu">Ügyfélkapu</ion-select-option>
                <ion-select-option value="cegkapu">Cégkapu</ion-select-option>
              </ion-select>
              <ion-input [(ngModel)]="hozza.mailbox_nev" label="Tárhely neve (nem kötelező)" labelPlacement="stacked"
                         placeholder="pl. adószám vagy „értesítési tárhely”" style="min-width:220px"></ion-input>
              <ion-button size="small" style="--background:var(--naplo)" (click)="hozzarendelesMent()">Mentés</ion-button>
              <ion-button size="small" fill="clear" (click)="hozza = null">Mégse</ion-button>
            </div>
          </td>
          <td>
            <ion-button size="small" fill="outline" (click)="ujHozzarendeles(u)" [disabled]="hozza?.ugyfel_id === u.id">
              <ion-icon slot="start" name="add"></ion-icon>Fiók
            </ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ion-note color="medium" *ngIf="fiokok.length" style="display:block; padding:4px 20px 24px; font-size:.8rem">
  A kódok 30 másodpercenként frissülnek (a kör jelzi a hátralévő időt). A jelszó és a TOTP secret titkosítva tárolódik;
  a kódot szerver-oldalon generáljuk.
</ion-note>

<!-- Fiók szerkesztő -->
<ion-modal #fiokModal class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>{{ szerk?.id ? 'Fiók módosítása' : 'Új fiók' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="fiokModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-item><ion-label position="stacked">Címke (megjelenő név)</ion-label><ion-input [(ngModel)]="szerk.cimke" placeholder="pl. Saját Ügyfélkapu+"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Login (felhasználónév) *</ion-label><ion-input [(ngModel)]="szerk.login" autocapitalize="off"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Jelszó {{ szerk.van_jelszo ? '(beállítva – üresen marad)' : '' }}</ion-label><ion-input type="password" [(ngModel)]="szerk.jelszo" placeholder="••••••"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">TOTP secret (2FA) {{ szerk.van_totp ? '(beállítva)' : '' }}</ion-label><ion-input [(ngModel)]="szerk.totp_secret" placeholder="pl. JBSWY3DPEHPK3PXP" autocapitalize="off"></ion-input></ion-item>
      <ion-item><ion-checkbox slot="start" [(ngModel)]="szerk.aktiv"></ion-checkbox><ion-label>Aktív</ion-label></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" (click)="mentes()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
